module.exports = __webpack_public_path__ + "img/logo.0aee90fe.png";